import {createAction, props} from '@ngrx/store';
import {IDeviceInfo} from '../../models/IDeviceInfo';

export const setDeviceTokenAndOperatingSystem = createAction('setDeviceTokenAndOperatingSystem', props<{ deviceInfo: IDeviceInfo }>());
